import React, { useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { TartaEmblem } from './TartaEmblem';
import { useLanguage } from '../context/LanguageContext';
export function Waitlist() {
  const {
    t
  } = useLanguage();
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: ''
  });
  const [errors, setErrors] = useState<{
    name?: string;
    email?: string;
  }>({});
  const [submitted, setSubmitted] = useState(false);
  const validate = () => {
    const e: typeof errors = {};
    if (!form.name.trim()) e.name = t.waitlist.required;
    if (!form.email.trim()) e.email = t.waitlist.required;else if (!/^\S+@\S+\.\S+$/.test(form.email)) e.email = t.waitlist.invalidEmail;
    setErrors(e);
    return Object.keys(e).length === 0;
  };
  const onSubmit = (e: any) => {
    e.preventDefault();
    if (!validate()) return;
    setSubmitted(true);
  };
  return <section id="waitlist" className="bg-texture-dark text-cream py-32 lg:py-48 relative overflow-hidden" data-id="element-290">
      <div className="max-w-[820px] mx-auto px-8 lg:px-14" data-id="element-291">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1.1,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative" data-id="element-292">
          <div className="absolute -inset-1 border border-cream/15 pointer-events-none" aria-hidden data-id="element-293" />
          <div className="border border-cream/25 px-8 py-16 sm:px-16 sm:py-20 lg:px-24 lg:py-24 text-center bg-chocolate/40 backdrop-blur-sm" data-id="element-294">
            <div className="flex flex-col items-center gap-8 mb-12" data-id="element-295">
              <TartaEmblem size={104} variant="dark" withTagline className="ring-1 ring-cream/20" data-id="element-296" />
              <span className="font-serif italic text-caramel text-[13px] tracking-[0.05em]" data-id="element-297">
                {t.waitlist.invitation}
              </span>
            </div>

            <h2 className="font-serif text-cream font-light leading-[0.95] tracking-[-0.025em]" style={{
            fontSize: 'clamp(44px, 7vw, 96px)'
          }} data-id="element-298">
              {t.waitlist.title1}
              <br data-id="element-299" />
              <span className="italic font-extralight" data-id="element-300">
                {t.waitlist.title2}
              </span>
            </h2>

            <p className="mt-10 text-cream/55 leading-[1.85] text-[15px] max-w-md mx-auto" data-id="element-301">
              {t.waitlist.copy}
            </p>

            <ul className="mt-12 flex flex-col sm:flex-row sm:flex-wrap items-center justify-center gap-y-4 sm:gap-x-6 lg:gap-x-10 text-[10px] tracking-[0.3em] uppercase text-cream/55" data-id="element-302">
              {t.waitlist.benefits.map((label, idx) => <Fragment key={label} data-id="element-303">
                  <li className="flex items-baseline gap-3 whitespace-nowrap" data-id="element-304">
                    <span className="font-serif italic text-caramel normal-case tracking-[0.05em] text-[13px]" data-id="element-305">
                      {['i.', 'ii.', 'iii.'][idx]}
                    </span>
                    <span data-id="element-306">{label}</span>
                  </li>
                  {idx < t.waitlist.benefits.length - 1 && <span className="hidden sm:inline w-1 h-1 rounded-full bg-caramel/50" aria-hidden data-id="element-307" />}
                </Fragment>)}
            </ul>

            {!submitted ? <form onSubmit={onSubmit} noValidate className="mt-16 max-w-md mx-auto text-left space-y-8" data-id="element-308">
                <Field label={t.waitlist.labelName} value={form.name} onChange={v => setForm({
              ...form,
              name: v
            })} error={errors.name} placeholder={t.waitlist.placeholderName} data-id="element-309" />
                <Field label={t.waitlist.labelEmail} type="email" value={form.email} onChange={v => setForm({
              ...form,
              email: v
            })} error={errors.email} placeholder={t.waitlist.placeholderEmail} data-id="element-310" />
                <Field label={t.waitlist.labelPhone} optionalLabel={t.waitlist.optional} optional type="tel" value={form.phone} onChange={v => setForm({
              ...form,
              phone: v
            })} placeholder={t.waitlist.placeholderPhone} data-id="element-311" />

                <div className="pt-8 text-center" data-id="element-312">
                  <button type="submit" className="group inline-flex items-center gap-5 text-cream" data-id="element-313">
                    <span className="w-12 h-px bg-cream/40 group-hover:bg-caramel group-hover:w-20 transition-all duration-500" data-id="element-314" />
                    <span className="font-serif italic text-[15px] tracking-[0.05em]" data-id="element-315">
                      {t.waitlist.submit}
                    </span>
                    <span className="w-12 h-px bg-cream/40 group-hover:bg-caramel group-hover:w-20 transition-all duration-500" data-id="element-316" />
                  </button>
                  <p className="mt-8 text-[10px] tracking-[0.3em] uppercase text-cream/35" data-id="element-317">
                    {t.waitlist.footnote}
                  </p>
                </div>
              </form> : <motion.div initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8
          }} className="mt-16" data-id="element-318">
                <p className="text-[10px] tracking-[0.5em] uppercase text-caramel mb-8" data-id="element-319">
                  {t.waitlist.confirmed}
                </p>
                <h3 className="font-serif text-4xl sm:text-5xl leading-[1.05] font-light" data-id="element-320">
                  {t.waitlist.welcome}
                  <br data-id="element-321" />
                  <span className="italic font-extralight" data-id="element-322">
                    {form.name.split(' ')[0]}.
                  </span>
                </h3>
                <p className="mt-8 text-cream/60 leading-[1.85] text-[15px] max-w-md mx-auto" data-id="element-323">
                  {t.waitlist.thanks}
                </p>
              </motion.div>}
          </div>
        </motion.div>
      </div>
    </section>;
}
function Field({
  label,
  value,
  onChange,
  error,
  type = 'text',
  placeholder,
  optional,
  optionalLabel
}: {
  label: string;
  value: string;
  onChange: (v: string) => void;
  error?: string;
  type?: string;
  placeholder?: string;
  optional?: boolean;
  optionalLabel?: string;
}) {
  return <div data-id="element-324">
      <div className="flex items-baseline justify-between mb-3" data-id="element-325">
        <label className="text-[10px] tracking-[0.3em] uppercase text-cream/50" data-id="element-326">
          {label}
        </label>
        {optional && <span className="text-[10px] tracking-[0.2em] uppercase text-cream/25" data-id="element-327">
            {optionalLabel}
          </span>}
      </div>
      <input type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} className="w-full bg-transparent border-b border-cream/20 focus:border-caramel outline-none py-3 text-cream placeholder:text-cream/25 transition-colors duration-500 font-serif text-lg" data-id="element-328" />
      {error && <p className="text-caramel/80 text-[10px] tracking-[0.2em] uppercase mt-3" data-id="element-329">
          {error}
        </p>}
    </div>;
}